'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var Tracer = require('./opentracing/tracer');

var tags = require('../../../ext/tags');

var scopes = require('../../../ext/scopes');

var platform = require('./platform');

var setStartupLogConfig = platform.startupLog.setStartupLogConfig;
var SPAN_TYPE = tags.SPAN_TYPE;
var RESOURCE_NAME = tags.RESOURCE_NAME;
var SERVICE_NAME = tags.SERVICE_NAME;
var ANALYTICS = tags.ANALYTICS;
var NOOP = scopes.NOOP;

var DatadogTracer =
/*#__PURE__*/
function (_Tracer) {
  _inherits(DatadogTracer, _Tracer);

  function DatadogTracer(config) {
    var _this;

    _classCallCheck(this, DatadogTracer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatadogTracer).call(this, config));
    _this._scopeManager = getScopeManager(config);
    _this._scope = getScope(config);
    setStartupLogConfig(config);
    return _this;
  }

  _createClass(DatadogTracer, [{
    key: "trace",
    value: function trace(name, options, fn) {
      options = Object.assign({}, {
        childOf: this.scope().active()
      }, options);

      if (!options.childOf && options.orphanable === false) {
        return fn(null, function () {});
      }

      var span = this.startSpan(name, options);
      addTags(span, options);

      try {
        if (fn.length > 1) {
          return this.scope().activate(span, function () {
            return fn(span, function (err) {
              addError(span, err);
              span.finish();
            });
          });
        }

        var result = this.scope().activate(span, function () {
          return fn(span);
        });

        if (result && typeof result.then === 'function') {
          result.then(function () {
            return span.finish();
          }, function (err) {
            addError(span, err);
            span.finish();
          });
        } else {
          span.finish();
        }

        return result;
      } catch (e) {
        addError(span, e);
        span.finish();
        throw e;
      }
    }
  }, {
    key: "wrap",
    value: function wrap(name, options, fn) {
      var tracer = this;
      return function () {
        var _this2 = this,
            _arguments = arguments;

        if (typeof options === 'function' && typeof fn === 'function') {
          options = options.apply(this, arguments);
        }

        if (options.orphanable === false && !tracer.scope().active()) {
          return fn.apply(this, arguments);
        }

        var lastArgId = arguments.length - 1;
        var cb = arguments[lastArgId];

        if (typeof cb === 'function') {
          var scopeBoundCb = tracer.scope().bind(cb);
          return tracer.trace(name, options, function (span, done) {
            _arguments[lastArgId] = function (err) {
              done(err);
              return scopeBoundCb.apply(this, arguments);
            };

            return fn.apply(_this2, _arguments);
          });
        } else {
          return tracer.trace(name, options, function () {
            return fn.apply(_this2, _arguments);
          });
        }
      };
    }
  }, {
    key: "scopeManager",
    value: function scopeManager() {
      return this._scopeManager;
    }
  }, {
    key: "scope",
    value: function scope() {
      return this._scope;
    }
  }, {
    key: "currentSpan",
    value: function currentSpan() {
      return this.scope().active();
    }
  }]);

  return DatadogTracer;
}(Tracer);

function addError(span, error) {
  if (error && error instanceof Error) {
    span.addTags({
      'error.type': error.name,
      'error.msg': error.message,
      'error.stack': error.stack
    });
  }
}

function addTags(span, options) {
  var tags = {};
  if (options.type) tags[SPAN_TYPE] = options.type;
  if (options.service) tags[SERVICE_NAME] = options.service;
  if (options.resource) tags[RESOURCE_NAME] = options.resource;
  tags[ANALYTICS] = options.analytics;
  span.addTags(tags);
}

function getScopeManager(config) {
  var ScopeManager;

  if (config.scope === NOOP) {
    ScopeManager = require('./scope/noop/scope_manager');
  } else {
    ScopeManager = require('./scope/scope_manager');
  }

  return new ScopeManager();
}

function getScope(config) {
  var Scope;

  if (config.scope === NOOP) {
    Scope = require('./scope/base');
  } else {
    Scope = platform.getScope(config.scope);
  }

  return new Scope(config);
}

module.exports = DatadogTracer;